import React from "react";
import { DiscountTableDesktop } from "./components/DiscountTableDesktop/DiscountTableDesktop.component";
import { DiscountTableMobile } from "./components/DiscountTableMobile/DiscountTableMobile.component";

interface V1DiscountRow {
    quantityFrom: number;
    quantityTo?: number;
    price: number;
}

interface V1Props {
    type?: "Desktop" | "Mobile"; // Make `type` optional in case it's not provided
    discountTable: V1DiscountRow[];
    currentQuantity?: number;
    onRowClick?: (quantity: number) => void;
    clickableRowsDesktop?: boolean;
    priceCurrency?: string;
}

export const V1 = (props: V1Props) => {
    const { type, discountTable, currentQuantity, onRowClick, clickableRowsDesktop } = props;

    if (type === "Desktop") {
        return (
            <DiscountTableDesktop
                discountTable={discountTable}
                currentQuantity={currentQuantity}
                onRowClick={onRowClick}
                clickableRowsDesktop={clickableRowsDesktop}
                priceCurrency={props.priceCurrency || "DKK"}
            />
        );
    }

    if (type === "Mobile") {
        return (
            <DiscountTableMobile
                discountTable={discountTable}
                priceCurrency={props.priceCurrency || "DKK"}
            />
        );
    }

    return null; // Return null if type is not defined or invalid
};
